class EuroPartners extends HTMLElement {
  connectedCallback() {
    this.mainEl = this.querySelector('[data-partners-main]');
    this.dotsEl = this.querySelector('[data-partners-dots]');
    this.mq = window.matchMedia('(min-width: 1200px)');
    this.onChange = () => this.sync();
    this.mq.addEventListener('change', this.onChange);
    this.whenReady(() => this.sync());
  }

  disconnectedCallback() {
    this.mq?.removeEventListener('change', this.onChange);
    clearInterval(this.readyTimer);
    this.destroy();
  }

  whenReady(callback) {
    if (window.Swiper) {
      callback();
      return;
    }

    this.readyTimer = setInterval(() => {
      if (!window.Swiper) return;
      clearInterval(this.readyTimer);
      callback();
    }, 30);
  }

  sync() {
    this.destroy();
    if (!this.mq.matches) this.init();
  }

  init() {
    if (this.mainSwiper || !this.mainEl || !window.Swiper) return;

    this.mainSwiper = new window.Swiper(this.mainEl, {
      slidesPerView: 1,
      spaceBetween: 0,
      speed: 500,
      watchOverflow: true,
      pagination: this.dotsEl
        ? {
            el: this.dotsEl,
            clickable: true,
          }
        : undefined,
    });
  }

  destroy() {
    this.mainSwiper?.destroy(true, true);
    this.mainSwiper = null;
  }
}

customElements.define('euro-partners', EuroPartners);
